import { getConfig } from "./secrets";

/**
 * Read a config key. These four always come from .env:
 * REACT_APP_BASE_URL, REACT_APP_BASE_URL_BASE, REACT_APP_BASE_URL_AI,
 * REACT_APP_GOOGLE_AUTH_URL. All other keys are loaded from
 * {BASE_URL_BASE}/api/v1/config/frontend at startup.
 */

export function getConfigValue(key, fallback = "") {
  try {
    const config = getConfig();
    if (config?.[key]) return config[key];
  } catch {
    // Secrets not loaded yet; fall back to CRA env.
  }
  return process.env[key] ?? fallback;
}
